// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const ESTQ_TIPO_LOCAL_ESTOCAGEM = {
  ProprioInterno: 'ESTQ_TIPO_LOCAL_ESTOCAGEM1',
  AlfandegadoOuEntreposto: 'ESTQ_TIPO_LOCAL_ESTOCAGEM2',
  TerceirosArmazemGeral: 'ESTQ_TIPO_LOCAL_ESTOCAGEM3',
  Transito: 'ESTQ_TIPO_LOCAL_ESTOCAGEM4',
  PreEmbarque: 'ESTQ_TIPO_LOCAL_ESTOCAGEM5',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    ESTQ_TIPO_LOCAL_ESTOCAGEM1: 1,
    ESTQ_TIPO_LOCAL_ESTOCAGEM2: 2,
    ESTQ_TIPO_LOCAL_ESTOCAGEM3: 3,
    ESTQ_TIPO_LOCAL_ESTOCAGEM4: 4,
    ESTQ_TIPO_LOCAL_ESTOCAGEM5: 5
  }
}
